import * as _ from 'lodash';
import * as moment from 'moment';
import { ChangeEvent, Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators } from '@nkr/store/index';
import { ICenterBase, IAllCentersGrid } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { Button, FormControl, Label, Well } from 'react-bootstrap';
import { downloadFile } from '@nkr/services/download-file';
import Grid from './grid';
import { IAllCentersGridResponse, IColdIschemiaLagTimeReportResponse } from '@nkr/store/reports';
import { IColdIschemiaLagTime } from '@nkr/models/reports';

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getColdIschemiaLagTimes: (startDate: string, endDate: string, centerId: number, csv: boolean) => Promise<IColdIschemiaLagTimeReportResponse>,
    getAllCentersData: () => Promise<IAllCentersGridResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: IColdIschemiaLagTime[],
    centerId: number,
    availableMonths: moment.Moment[],
    startDate: string,
    endDate: string,
    selectedMonth: string,
    movingKidneysCount: number,
    inComplianceCount: number,
    includedCount: number,
    complianceRate: number,
    centerData: IAllCentersGrid[]
}


const getDates = () => {
    let currentDate = moment().startOf('month');
    let list: moment.Moment[] = [];

    for (let i = 0; i <= 36; i++) {
        var newMoment = moment(currentDate.format('YYYY-MM-DD'));
        list.push(newMoment);
        currentDate = currentDate.subtract(1, 'months');
    }

    return list;
};

class ColdIschemiaLagTimeReport extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        centerId: this.props.centerId > 0 ? this.props.centerId : 0,
        availableMonths: getDates(),
        endDate: moment().endOf("month").format('YYYY-MM-DD'),
        startDate: moment().endOf("month").add(-3, 'month').format('YYYY-MM-DD'),
        selectedMonth: moment().startOf('month').format('YYYY-MM-DD'),
        movingKidneysCount: 0,
        inComplianceCount: 0,
        includedCount: 0,
        complianceRate: 0,
        centerData: []
    };


    componentDidMount = () => {
        this.getData();
    }


    getData = () => {
        this.props.showLoading("Getting data, one moment please...")
            .then(() => {
                return Promise.all([
                    this.props.getColdIschemiaLagTimes(this.state.startDate, this.state.endDate, this.state.centerId, false),
                    this.props.getAllCentersData()
                ]);
            })
            .then(([pickupResponse, centerDataResponse]) => {
                let list = pickupResponse.data.results || [];
                let movingKidneysCount = list.length;
                let inComplianceCount = list.filter(x => x.isCompliant == 'Y').length;
                let includedCount = list.length;

                let complianceRate = includedCount > 0
                    ? parseFloat(((inComplianceCount / includedCount) * 100).toFixed(0))
                    : 0;

                let centerData = centerDataResponse.data.results || [];

                this.setState({
                    list,
                    movingKidneysCount,
                    inComplianceCount,
                    includedCount,
                    complianceRate,
                    centerData
                });
            })
            .catch(() => {
                // any failure hides loading
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    getCenterList = () => {
        let results: ICenterBase[] = [];

        for (let n = 0; n < this.state.list.length; n++) {
            let item = this.state.list[n];
            let exists = results.find(x => x.id == item.donorCenterId);

            if (exists == null) {
                results.push({
                    id: item.donorCenterId,
                    alias: item.donorCenter,
                    name: '',
                    isMemberCenter: true,
                    centerAddresses: []
                });
            }
        }

        return _.orderBy(results, (item) => {
            return item.alias
        }, 'asc');
    }


    handleExport = () => {
        this.props.showLoading('Exporting CSV file, one moment please...').then(() => {
            this.props.getColdIschemiaLagTimes(this.state.startDate, this.state.endDate, this.state.centerId, true).then(response => {
                downloadFile(response.data, `cold-ischemia-lag-times-export`, 'text/csv');

                this.props.hideLoading();
            });
        });
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (name == 'endDate') {
            this.setState({
                endDate: value
            });
        }
    }

    handleDateRangeSearch = () => {
        this.getData();
    }

    handleStartDateChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let selectedMonth = e.currentTarget.value;

        let end = moment(selectedMonth).endOf("month");
        let start = end;
        let endDate = end.format("YYYY-MM-DD");
        start.subtract(3, 'months');
        let startDate = start.format("YYYY-MM-DD");

        this.setState({ selectedMonth, startDate, endDate }, () => {
            this.getData();
        });
    };

    handleCenterChange = (e: ChangeEvent<FormControl & HTMLSelectElement>) => {
        const centerId = parseInt(e.currentTarget.value);

        this.setState({
            centerId
        },
            () => {
                this.props.hideLoading();
                this.getData();
            }
        );
    };


    getFilteredData = () => {
        let filteredData = this.state.list.filter(x => {
            return this.state.centerId == 0 ? true : this.state.centerId == x.donorCenterId || this.state.centerId == x.remoteDonorCenterId;
        });

        return filteredData;
    }

    getDisplay = () => {
        return this.props.centerId > 0 ? 'none' : 'flex';
    }

    render = () => {
        const centerList = _.sortBy(this.state.centerData, [(c) => c.alias?.toLowerCase()]);
        const filteredList = this.getFilteredData();

        return (
            <>
                {this.props.centerId == null && (
                    <div style={{ fontSize: 28, fontWeight: 500, marginBottom: 20 }}>Cold Ischemia Lag Time for Moving Kidneys</div>
                )}

                <div
                    style={{
                        minHeight: 500,
                        paddingLeft: this.props.isCenterLogin ? 10 : 0,
                        paddingRight: this.props.isCenterLogin ? 10 : 0,
                    }}
                >
                    <Well
                        bsStyle="sm"
                        style={{
                            paddingTop: 6,
                            paddingBottom: 6,
                            marginBottom: 10,
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                flexWrap: this.props.centerId < 1 ? "nowrap" : "wrap", // prevent wrapping when <1
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flex: 2,
                                    marginLeft: this.props.centerId < 1 ? 100 : 0, // shift right when <1
                                    gap: this.props.centerId < 1 ? 25 : 0,
                                    flexWrap: "nowrap",
                                }}
                            >
                                {/* Reference Month (only visible when centerId > 0) */}
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: "center",
                                        marginRight: this.props.centerId < 1 ? 15 : 40,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <div style={{ marginRight: 8 }}>Select Reference Month:</div>
                                    <FormControl
                                        componentClass="select"
                                        value={this.state.selectedMonth}
                                        onChange={this.handleStartDateChange}
                                        style={{ width: 170 }}
                                    >

                                        {this.state.availableMonths.map((availableMonth, index) => (
                                            <option
                                                key={"d-" + index}
                                                value={moment(availableMonth).format("YYYY-MM-DD")}
                                            >
                                                {availableMonth.format("MMM YYYY")}
                                            </option>
                                        ))}
                                    </FormControl>
                                </div>
                                <div
                                    style={{
                                        display: this.getDisplay(),
                                        alignItems: "center",
                                        marginRight: this.props.centerId < 1 ? 15 : 40,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <div style={{ marginRight: 8 }}>Donor Center:</div>
                                    <FormControl
                                        componentClass="select"
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}
                                        style={{
                                            width: this.props.centerId < 1 ? 180 : 200,
                                        }}
                                    >
                                        <option value={0}>- ALL -</option>
                                        {centerList.map((item, index) => (
                                            <option key={"ctr-" + index} value={item.id}>
                                                {item.alias}
                                            </option>
                                        ))}
                                    </FormControl>
                                </div>
                            </div>

                            {/* Summary Table */}
                            <div
                                style={{
                                    flex: 3,
                                    display: "flex",
                                    justifyContent: this.props.centerId < 1 ? "center" : "flex-start",
                                }}
                            >
                                <TableWrapper
                                    className="table table-condensed"
                                    style={{
                                        marginBottom: 0,
                                        borderTop: "1px solid #ccc",
                                        width: "auto",
                                        backgroundColor: "white",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                rowSpan={2}
                                                style={{
                                                    backgroundColor: "#133366",
                                                    color: "white",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    fontWeight: 600,
                                                    padding: "12px 20px",
                                                    minWidth: "250px",
                                                }}
                                            >
                                                {this.state.movingKidneysCount ?? 5} Moving Kidneys in Report Range
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: "#133366",
                                                    color: "white",
                                                    textAlign: "center",
                                                    fontWeight: 600,
                                                    padding: "8px 14px",
                                                }}
                                            >
                                                # In Compliance
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: "#133366",
                                                    color: "white",
                                                    textAlign: "center",
                                                    fontWeight: 600,
                                                    padding: "8px 14px",
                                                }}
                                            >
                                                # Included
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: "#133366",
                                                    color: "white",
                                                    textAlign: "center",
                                                    fontWeight: 600,
                                                    padding: "8px 14px",
                                                }}
                                            >
                                                CIT Compliance Rate
                                            </th>
                                        </tr>
                                        <tr>
                                            <th style={{ textAlign: "center", padding: "8px 14px", fontWeight: 500 }}>
                                                {this.state.inComplianceCount ?? 2}
                                            </th>
                                            <th style={{ textAlign: "center", padding: "8px 14px", fontWeight: 500 }}>
                                                {this.state.includedCount ?? 5}
                                            </th>
                                            <th style={{ textAlign: "center", padding: "8px 14px", fontWeight: 500 }}>
                                                {this.state.complianceRate ?? 40}%
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody />
                                </TableWrapper>
                            </div>

                            {/* Export Button */}
                            <div style={{ flexShrink: 0, marginLeft: 20 }}>
                                <Button
                                    onClick={() => this.handleExport()}
                                    bsStyle="primary"
                                    style={{
                                        whiteSpace: "nowrap",
                                        height: "fit-content",
                                        alignSelf: "center",
                                    }}
                                >
                                    Export CSV
                                </Button>
                            </div>
                        </div>
                    </Well>

                    <p>* The cold ischemia lag time is defined as the elapsed time between the cross-clamp time and the scheduled pickup time.</p>

                    <Grid data={filteredList} centerId={this.props.centerId} />
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getColdIschemiaLagTimes: (startDate, endDate, centerId, csv) => {
            return dispatch(ReportActionCreators.getColdIschemiaLagTimes(startDate, endDate, centerId, csv));
        },
        getAllCentersData: () => {
            return dispatch(ReportActionCreators.getAllCentersData());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ColdIschemiaLagTimeReport);